import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';

import { GuideModel } from '@app/core/models';
import { IGuideApiModel, IGuideListGetRequest } from '@app/core/models/api';

@Injectable()
export class GuideApiService {
  constructor(private http: HttpClient) {}

  getGuidesByCluster(cluster?: number): Observable<Array<GuideModel>> {
    let req: IGuideListGetRequest = {};

    if (cluster) {
      req.cluster = cluster;
    }

    return this.getGuideList(req);
  }

  getGuideDetails(guide: number): Observable<GuideModel> {
    const params = new HttpParams({
      fromObject: {
        guide: `${guide}`,
        with_beacons: '1',
      },
    });

    return this.http
      .get<IGuideApiModel>(`${environment.API_URL}v5/guide.json`, { params })
      .pipe(map(item => new GuideModel(item)));
  }

  getGuideDetailsBySlug(slug: string): Observable<GuideModel> {
    const params = new HttpParams({
      fromObject: {
        slug: `${slug}`,
        with_beacons: '1',
      },
    });

    return this.http
      .get<IGuideApiModel>(`${environment.API_URL}v5/guide.json`, { params })
      .pipe(map(item => new GuideModel(item)));
  }

  private getGuideList(
    req: IGuideListGetRequest,
  ): Observable<Array<GuideModel>> {
    return this.http
      .get<Array<IGuideApiModel>>(`${environment.API_URL}v5/guides.json`, {
        params: new HttpParams({ fromObject: req as any }),
      })
      .pipe(map(res => res.map(item => new GuideModel(item))));
  }

  // getBusinessGuides(): Observable<Array<IGuideModel>> {
  //   const params = new HttpParams(); // .append('user', username);

  //   return this.http.get<Array<IGuideModel>>(
  //     `${environment.API_URL}v5/guides.json`,
  //     {
  //       params,
  //     },
  //   );
  // }
}
